import { httpRequest } from "@/lib";
import { RuleResponse } from "@/types";
import { useQuery } from "@tanstack/react-query";

async function fetchRules(): Promise<RuleResponse> {
  const response = await httpRequest.get<RuleResponse>(`/roles`);
  return response.data;
}

export function useFetchRulesQuery() {
  const rulesResponseQuery = useQuery({
    queryKey: ["roles"],
    queryFn: () => fetchRules(),
    keepPreviousData: true,
  });

  return {
    ...rulesResponseQuery,
    data: rulesResponseQuery?.data,
  };
}
